exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\r\n    display: flex;\r\n    flex-grow: 0;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.title-bar-container {\r\n    flex-grow: 1;\r\n}\r\n\r\n.title-bar {\r\n    flex-grow: 1;\r\n    display: flex;\r\n    background-color: #f9f9f9;\r\n    height: 90px;\r\n    padding: 10px;\r\n    padding-left: 40px;\r\n}\r\n\r\n.title-bar-line {\r\n    height: 1px;\r\n    background-color: #c4c4c4;\r\n}\r\n\r\n.menu-area {\r\n    display: flex; \r\n    flex-direction: column; \r\n    flex-grow: 1;\r\n    padding-right: 20px;\r\n}\r\n\r\n.title-bar-small {\r\n    flex-grow: 1;\r\n    display: flex;\r\n    min-height: 56px;\r\n}\r\n\r\n.small-image-holder {\r\n    flex-grow: 1;\r\n}\r\n\r\n.small-image {\r\n    height: 50px;\r\n}\r\n\r\nspan {\r\n    margin-left: 10px;\r\n    margin-right: 20px;\r\n    font-size: 25px;\r\n    line-height: 50px;\r\n}\r\n\r\n\r\n\r\n\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Scripts/fw/title-bar/title-bar.component.css
// module id = 1861
// module chunks = 1